const getLayoutPage = ()=>document.querySelector('.layout-page');
export default {
    name: 'IssuableBulkEditSidebar',
    props: {
        expanded: {
            type: Boolean,
            required: true
        }
    },
    watch: {
        expanded (value) {
            const layoutPageEl = getLayoutPage();
            if (layoutPageEl) {
                layoutPageEl.classList.toggle('right-sidebar-expanded', value);
                layoutPageEl.classList.toggle('right-sidebar-collapsed', !value);
            }
        }
    },
    mounted () {
        const layoutPageEl = getLayoutPage();
        if (layoutPageEl) {
            layoutPageEl.classList.add('issuable-bulk-update-sidebar');
        }
    }
};
